/* VB · capa global de motion (ver assets/vb-motion.css y _review/MOTION.md).
   No edita secciones: se engancha a sus clases. Sin JS o con prefers-reduced-motion todo queda visible y estático. */
(() => {
  if (window.__vbMotion) return;
  window.__vbMotion = true;
  const P = window.VB || {};
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const design = !!(window.Shopify && Shopify.designMode);
  const main = document.getElementById('MainContent') || document.body;

  /* 1 · Reveal con escalonado. Reutiliza .vb-reveal/.is-in de vb.css; solo se marca lo que está por DEBAJO
     del viewport al cargar (lo ya pintado no se esconde) y, al terminar, se quitan las clases para que el
     elemento recupere sus propias transiciones. */
  const SINGLES = '.vb-featured__heading, .vb-look__heading, .vb-cshow__heading, .vb-pack-builder__head, .vb-fp__heading, .vb-b2b-benefits__title'
    /* VeraBelleza (27-oct): títulos y entradillas de las secciones VB */
    + ', .vb-home-best__title, .vb-home-best__intro, .vb-pack__head, .vb-home-ugc__head, .vb-home-look__title, .vb-home-why__title'
    + ', .vb-home-rev__head, .vb-pres__title, .vb-phow__title, .vb-pcmp__title, .vb-prev__head'
    + ', .vb-pcomb__title, .vb-pcomb__intro, .vb-pack-faq__title, .vb-faq__title, .vb-am__title, .vb-am__text, .vb-as__body'
    + ', .vb-av__title, .vb-apr__title, .vb-apr__intro, .vb-cf__title, .vb-aq__in';
  const GROUPS = '.vb-cshow__list, .vb-feat__grid, .vb-cbento__grid, .vb-b2b-benefits__grid, .vb-b2b-cats__list, .vb-plp__grid'
    + ', .vb-home-benefits__grid, .vb-pres__list, .vb-phow__steps, .vb-av__grid, .vb-pack-faq__list';
  const TRACKS = '.vb-featured__track, .vb-look__track'
    + ', .vb-home-best__track, .vb-home-ugc__track, .vb-home-rev__track, .vb-prev__track, .vb-pcomb__track, .vb-apr__track';
  /* Fotos grandes: suben con fundido y la imagen se aleja despacio (1,08 → 1) · data-m-media + .m-in */
  const MEDIA = '.vb-home-look__media, .vb-home-why__media, .vb-pres__media, .vb-as__media, .vb-phow__media';
  const STEP = 0.08, MAX_I = 6;

  const done = (el) => {
    el.classList.remove('vb-reveal', 'is-in');
    el.style.removeProperty('--reveal-delay');
    delete el.dataset.mRv;
  };
  const marked = new Set();
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => entries.forEach((en) => {
        const el = en.target;
        if (!en.isIntersecting) {
          // Ya quedó por encima (scroll restaurado al recargar/volver): se muestra sin animar
          if (en.boundingClientRect.bottom < 0) { io.unobserve(el); marked.delete(el); done(el); }
          return;
        }
        io.unobserve(el);
        marked.delete(el);
        el.classList.add('is-in');
        const delay = parseFloat(el.style.getPropertyValue('--reveal-delay')) || 0;
        setTimeout(() => done(el), (delay + 0.9) * 1000);
      }), { rootMargin: '0px 0px -8% 0px', threshold: 0.05 })
    : null;

  const below = (el) => el.getBoundingClientRect().top > innerHeight;
  const mark = (el, i = 0) => {
    if (el.classList.contains('vb-reveal') || el.closest('.vb-reveal')) return;
    el.dataset.mRv = '';
    if (i) el.style.setProperty('--reveal-delay', `${Math.min(i, MAX_I) * STEP}s`);
    el.classList.add('vb-reveal');
    marked.add(el);
    io.observe(el);
  };
  /* El navegador restaura el scroll DESPUÉS de este script (y un salto de ancla o de paginación también se lo
     salta): lo que queda por encima del viewport sin haber pasado por él no cruza ningún umbral del observer y se
     quedaría oculto. Se barre en el load/pageshow y al hacer scroll: lo de la capa se muestra sin animar y lo del
     reveal propio del tema (.vb-reveal de vb.js) recibe su .is-in. */
  let sweepRaf = 0;
  const sweepAbove = () => {
    sweepRaf = 0;
    marked.forEach((el) => {
      if (el.getBoundingClientRect().bottom < 0) { io.unobserve(el); marked.delete(el); done(el); }
    });
    document.querySelectorAll('.vb-reveal:not(.is-in):not([data-m-rv])').forEach((el) => {
      if (el.getBoundingClientRect().bottom < 0) el.classList.add('is-in');
    });
  };
  const onScroll = () => { if (!sweepRaf) sweepRaf = requestAnimationFrame(sweepAbove); };
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('load', () => requestAnimationFrame(sweepAbove));
  addEventListener('pageshow', () => requestAnimationFrame(sweepAbove));

  /* Carruseles con reveal propio del tema (reseñas, UGC): una tarjeta a la que se salta sin pasar por pantalla
     (punto de paginación, scroll directo) nunca cruzaría el observer → al desplazar el track se revela todo lo
     que ya se ha alcanzado o rebasado. */
  let trackRaf = 0;
  document.addEventListener('scroll', (e) => {
    const t = e.target;
    if (!(t instanceof HTMLElement) || trackRaf || !t.querySelector(':scope > .vb-reveal:not(.is-in)')) return;
    trackRaf = requestAnimationFrame(() => {
      trackRaf = 0;
      const edge = t.getBoundingClientRect().right;
      t.querySelectorAll(':scope > .vb-reveal:not(.is-in)').forEach((c) => {
        if (c.getBoundingClientRect().left < edge) c.classList.add('is-in');
      });
    });
  }, { capture: true, passive: true });
  const mio = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => entries.forEach((en) => {
        const el = en.target;
        if (!en.isIntersecting && en.boundingClientRect.bottom >= 0) return;
        mio.unobserve(el);
        el.classList.add('m-in');
        setTimeout(() => { el.classList.remove('m-in'); delete el.dataset.mMedia; }, 1700);
      }), { rootMargin: '0px 0px -10% 0px', threshold: 0.05 })
    : null;
  const reveal = (scope) => {
    if (!io || design || reduce() || !document.documentElement.classList.contains('vb-js-reveal')) return;
    scope.querySelectorAll(MEDIA).forEach((el) => {
      if (!below(el) || el.closest('.vb-reveal') || el.dataset.mMedia !== undefined) return;
      el.dataset.mMedia = '';
      mio.observe(el);
    });
    scope.querySelectorAll(SINGLES).forEach((el) => { if (below(el)) mark(el); });
    // Rejillas: cada hijo que esté por debajo del pliegue, escalonado por su posición dentro de la fila
    scope.querySelectorAll(GROUPS).forEach((g) => {
      let rowTop = null, col = 0;
      [...g.children].filter((c) => c.offsetParent !== null).forEach((c) => {
        const top = Math.round(c.getBoundingClientRect().top);
        col = top === rowTop ? col + 1 : 0;
        rowTop = top;
        if (top > innerHeight) mark(c, col);
      });
    });
    // Carrusel: solo las tarjetas enteras dentro del ancho visible (las de fuera o la que asoma por el borde nunca
    // llegarían al umbral del observer y se quedarían en blanco)
    scope.querySelectorAll(TRACKS).forEach((t) => {
      if (!below(t)) return;
      let i = 0;
      [...t.children].forEach((c) => {
        const r = c.getBoundingClientRect();
        if (c.offsetParent !== null && r.left >= 0 && r.right <= innerWidth + 1) mark(c, i++);
      });
    });
  };

  /* 2 · Imágenes diferidas: fundido al cargar (no toca las eager, la 2.ª foto de la tarjeta ni iconos/banderas). */
  const fade = (img) => {
    if (img.complete || img.dataset.mFade || img.classList.contains('vb-card__img--2')) return;
    if ((parseInt(img.getAttribute('width'), 10) || 999) < 120) return;
    // Oculta por su sección (p. ej. fotos inactivas del showcase, que entran con su propio barrido): no se toca
    if (getComputedStyle(img).visibility === 'hidden') return;
    img.dataset.mFade = 'wait';
    const show = () => {
      img.dataset.mFade = 'in';
      img.addEventListener('animationend', () => delete img.dataset.mFade, { once: true });
      setTimeout(() => delete img.dataset.mFade, 900);
    };
    img.addEventListener('load', show, { once: true });
    img.addEventListener('error', () => delete img.dataset.mFade, { once: true });
  };
  const fadeAll = (scope) => {
    if (reduce()) return;
    scope.querySelectorAll('img[loading="lazy"]').forEach(fade);
  };
  new MutationObserver((list) => list.forEach((m) => m.addedNodes.forEach((n) => {
    if (n.nodeType !== 1) return;
    if (n.matches('img[loading="lazy"]')) fade(n); else if (!reduce()) n.querySelectorAll?.('img[loading="lazy"]').forEach(fade);
  }))).observe(main, { childList: true, subtree: true });

  /* 3 · Contador del carrito: rebote cuando sube. */
  const bump = (el) => { el.classList.remove('vb-m-bump'); void el.offsetWidth; el.classList.add('vb-m-bump'); };
  document.querySelectorAll('[data-vb-cart-count]').forEach((el) => {
    let last = parseInt(el.textContent, 10) || 0;
    el.addEventListener('animationend', () => el.classList.remove('vb-m-bump'));
    new MutationObserver(() => {
      const n = parseInt(el.textContent, 10) || 0;
      if (n > last && !el.hidden) bump(el);
      last = n;
    }).observe(el, { childList: true, characterData: true, subtree: true });
  });

  /* 4 · Añadido al carrito: el botón pulsado que pasa por is-loading muestra un check si el carrito se actualizó.
     Se observa SOLO ese botón (10 s), no el documento. */
  let cartTick = 0;
  document.addEventListener('vb:cart:updated', () => { cartTick = Date.now(); });
  const success = (b) => {
    const c = getComputedStyle(b);
    if (c.position !== 'static' && c.position !== 'relative') return;
    b.style.setProperty('--m-check', c.color);
    if (c.position === 'static') b.style.position = 'relative';
    b.classList.add('vb-m-done');
    setTimeout(() => { b.classList.remove('vb-m-done'); b.style.removeProperty('--m-check'); if (c.position === 'static') b.style.position = ''; }, 1200);
  };
  const watch = (b) => {
    // El constructor de packs ya tiene su propio estado de éxito (caras + huellas): no se le superpone el check
    if (!b || b.__vbWatch || reduce() || !b.matches('button, a.vb-btn') || b.hasAttribute('data-state') || b.closest('.vb-pack-builder')) return;
    let t0 = 0;
    const mo = new MutationObserver(() => {
      if (b.classList.contains('is-loading')) { t0 = t0 || Date.now(); return; }
      if (!t0) return;
      stop();
      if (cartTick >= t0) success(b);
    });
    const stop = () => { mo.disconnect(); clearTimeout(timer); b.__vbWatch = false; };
    const timer = setTimeout(stop, 10000);
    b.__vbWatch = true;
    mo.observe(b, { attributes: true, attributeFilter: ['class'] });
  };
  document.addEventListener('submit', (e) => watch(e.submitter || e.target.querySelector('[type="submit"]')), true);
  document.addEventListener('click', (e) => watch(e.target.closest('button[type="button"], a.vb-btn')), true);

  /* 5 · Favorito: bamboleo al marcarlo. */
  document.addEventListener('click', (e) => {
    const f = e.target.closest('[data-vb-fav]');
    if (!f || reduce()) return;
    setTimeout(() => {
      if (f.getAttribute('aria-pressed') !== 'true') return;
      f.classList.remove('vb-m-wobble'); void f.offsetWidth; f.classList.add('vb-m-wobble');
      setTimeout(() => f.classList.remove('vb-m-wobble'), 700);
    }, 0);
  });

  /* 6 · Arrastre con ratón + inercia en todos los carruseles [data-vb-scroller] (reutiliza VB.drag). */
  const drag = (scope) => {
    if (typeof P.drag !== 'function') return;
    scope.querySelectorAll('[data-vb-scroller] [data-vb-track]:not([data-vb-drag])').forEach((t) => {
      t.setAttribute('data-vb-drag', '');
      P.drag(t);
    });
  };

  const init = (scope = document) => { reveal(scope); fadeAll(scope === document ? main : scope); drag(scope); };
  init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    if (io) e.target.querySelectorAll('[data-m-rv]').forEach((el) => { io.unobserve(el); done(el); });
  });
})();
